import React, { useState, useEffect } from 'react'

const DriverHistoryComponent = (props) => {
    // allow backend routes
    var CryptoJS = require("crypto-js");
    console.log(props)

    // state
    const [ listOfDrivers, setListOfDrivers ] = useState([])
    const [ content, setContent ] = useState(null)

    // request data relating to the vehicle
    useEffect( () => {
        console.log(props)
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            
            return response ? response.json() : console.log('no reponse')
        };
        if (props.selectedVan) {
            console.log('inside here: ', props.selectedVan.registration)
            postData(`https://backendpajamas.herokuapp.com/driverhistory/`, {
                vehicle_id: props.selectedVan.registration
            }).then(response => {
                if (response.data) {
                    if (response.data.length > 0) {
                        response.data.sort((a, b) => (new Date(a.date) > new Date(b.date) ? -1 : 1))
                    }
                }
                setListOfDrivers(response.data)
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]) 

    useEffect( () => {
        if (listOfDrivers.length > 0 && listOfDrivers !== undefined) {
            let localArray = []
            listOfDrivers.forEach( driver => {
                localArray.push(
                    <div className='insideArrayUnit'>
                        <h3>Van Assigned Week: {new Date(driver.date).toLocaleDateString('en-GB')}</h3>
                        <h3>{driver.endDate ? `Van return week: ${new Date(driver.endDate).toLocaleDateString('en-GB')}` : 'Still in Use'}</h3>
                        <h3>Driver assigned to the Van: {driver.name}</h3>
                    </div>
                )
            })
            setContent(
                <div className='overallDisplay'>
                    {localArray}
                </div>
            )
        }
    }, [listOfDrivers])

    return(
        <>
            {content}
        </>
    )
}

export default DriverHistoryComponent